export default "__VITE_ASSET__ByimJ3yx__"